import { createSlice } from "@reduxjs/toolkit";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logBookService } from "../services/lessonService";
import { createCustomAsyncThunk } from "./utils";

export const getLogbook = createCustomAsyncThunk(
    "logBook/get",
    async params => await logBookService.get(params)
)

const createLogbookItem = createCustomAsyncThunk(
    "logBook/createMark",
    async data => await logBookService.postItems(data).then(res => ({ data: { ...data, ...res.data } }))
)

const updateLogbookItem = createCustomAsyncThunk(
    "logBook/updateMark",
    async data => await logBookService.patchItems(data).then(res => ({ data: { ...data, ...res.data } }))
)

const deleteLogbookItem = createCustomAsyncThunk(
    "logBook/deleteMark",
    async data => await logBookService.deleteItems(data).then(res => ({ data: { ...data, ...res.data } }))
)

const logBookSlice = createSlice({
    name: "logBook",
    initialState: {
        data: [],
        isLoading: false,
        isUpdating: false,
        error: null,
    },
    reducers: {
        resetLogBook: state => { state.data = [] }
    },
    extraReducers: builder => {
        builder
            .addCase(getLogbook.pending, state => { state.isLoading = true })
            .addCase(getLogbook.fulfilled, (state, action) => {
                state.data = action.payload
                state.isLoading = false
            })
            .addCase(getLogbook.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(createLogbookItem.pending, state => { state.isUpdating = true })
            .addCase(createLogbookItem.fulfilled, (state, action) => {
                state.data[action.payload.studentIndex].logbook_items[action.payload.date][action.payload.lessonIndex] = {
                    ...state.data[action.payload.studentIndex].logbook_items[action.payload.date][action.payload.lessonIndex],
                    ...action.payload
                }
                state.isUpdating = false
            })
            .addCase(createLogbookItem.rejected, (state, action) => {
                state.error = action.error
                state.isUpdating = false
            })

            .addCase(updateLogbookItem.pending, state => { state.isUpdating = true })
            .addCase(updateLogbookItem.fulfilled, (state, action) => {
                state.data[action.payload.studentIndex].logbook_items[action.payload.date][action.payload.lessonIndex] = {
                    ...state.data[action.payload.studentIndex].logbook_items[action.payload.date][action.payload.lessonIndex],
                    ...action.payload
                }
                state.isUpdating = false
            })
            .addCase(updateLogbookItem.rejected, (state, action) => {
                state.error = action.error
                state.isUpdating = false
            })

            .addCase(deleteLogbookItem.pending, state => { state.isUpdating = true })
            .addCase(deleteLogbookItem.fulfilled, (state, action) => {
                state.data[action.payload.studentIndex].logbook_items[action.payload.date][action.payload.lessonIndex] = {
                    ...state.data[action.payload.studentIndex].logbook_items[action.payload.date][action.payload.lessonIndex],
                    id: null,
                    value: null
                }
                state.isUpdating = false
            })
            .addCase(deleteLogbookItem.rejected, (state, action) => {
                state.error = action.error
                state.isUpdating = false
            })

    }
})

export default logBookSlice.reducer

export const { resetLogBook } = logBookSlice.actions


export const useLogBook = (group, subject, study_year) => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (group && subject) { dispatch(getLogbook({ group_id: group, subject_id: subject, study_year })) }
        return () => dispatch(resetLogBook())
    }, [dispatch, group, subject, study_year])

    const logBook = useSelector(x => x.logBook.data)
    const logBookIsLoading = useSelector(x => x.logBook.isLoading)

    const updateLogbook = (data, value) => {
        const preparedValues = { ...data, value: value === "·" ? null : value } // зачем это?

        return dispatch(
            // value === "·" ? deleteLogbookItem(preparedValues) :
                preparedValues.id ? updateLogbookItem(preparedValues) : createLogbookItem(preparedValues)).unwrap()
    }

    return { logBook, logBookIsLoading, updateLogbook }
}